import { FC, ReactElement } from 'react';

import { ProductPriceInterface } from '../../entities/Price/Price';
import { useTrans } from '../../hooks';

import './DiscountLabel.scss';

interface DiscountLabel {
    price: ProductPriceInterface;
    className?: string;
}

export const DiscountLabel: FC<DiscountLabel> = ({
    price,
    className = '',
}): ReactElement | null => {
    const trans = useTrans();

    if (!price.discount) {
        return null;
    }

    return (
        <div className={`discount-label ${className}`}>
            {price.discount.isPercentage && (
                <p className="discount-label__text">
                    {trans('compositions.discountLabel.percentage', {
                        discountInPercentage: price.discountInPercentage,
                    })}
                </p>
            )}

            {!price.discount.isPercentage && (
                <p className="discount-label__text">
                    {trans('compositions.discountLabel.price', {
                        discountInPrice: price.discountInPrice,
                    })}
                </p>
            )}
        </div>
    );
};
